import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IMenuItem } from '@components/common/SideBar/interfaces';

import { TVendorsValues } from '@enums/common';

type TSelectedVendor = TSelectOption<TVendorsValues> | null

interface IInitialState {
	selectedVendor: TSelectedVendor | null;
	vendorDrivenFeatures: IMenuItem[];
}

export const initialState: IInitialState = {
	selectedVendor: null,
	vendorDrivenFeatures: [],
};

const configurationManagement = createSlice({
	name: 'configurationManagement',
	initialState,
	reducers: {
		setSelectedVendor: (state, action: PayloadAction<TSelectedVendor>) => {
			state.selectedVendor = action.payload;
		},
		setVendorDrivenFeatures: (state, action: PayloadAction<IMenuItem[]>) => {
			state.vendorDrivenFeatures = action.payload;
		},
	},
});

export const {
	setSelectedVendor,
	setVendorDrivenFeatures,
} = configurationManagement.actions;

export default configurationManagement.reducer;
